module.exports = __webpack_public_path__ + "./fonts/SF-Pro-Display-MediumItalic.otf";